function kebabCaseToCamelCase(str) {
    return str
        .split('-')
        .map((word, index) => (index ? capitalizeFirstChar(word) : word))
        .join('');
}
function camelCaseToKebabCase(str) {
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
function isLowerCase(str) {
    return /^[a-z]*$/.test(str);
}
function capitalizeFirstChar(str) {
    if (!str) {
        return str;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const firstChar = str[0].toUpperCase();
    return `${firstChar}${str.slice(1)}`;
}

export { camelCaseToKebabCase, isLowerCase, kebabCaseToCamelCase };
//# sourceMappingURL=wordsCase.mjs.map
